<template>
   <vs-td>
      <div class="device-info">
        <div class="shadow-drop d-theme-dark-bg cursor-pointer round">
        <vs-avatar class="block" color="danger" icon="notification_important" size="small" v-if="status"/>
        <vs-avatar class="block" color="#18cd5b" icon="check" size="small" v-if="!status"/>
        </div>
        <div class="device-text-container">
          <span class="main-info" v-if="status">{{$t("Messages.Alert")}}</span>
          <span class="main-info" v-if="!status">{{$t("Messages.Correct")}}</span>
          <span class="subtext-info">{{$t("Messages.State")}}</span>
        </div>
      </div>
    </vs-td>
</template>
<script>
export default {
  props:{
    status: Boolean
  }
}
</script>